import { render, staticRenderFns } from "./dashBoardmain.vue?vue&type=template&id=9ad2567c&scoped=true&"
import script from "./dashBoardmain.vue?vue&type=script&lang=js&"
export * from "./dashBoardmain.vue?vue&type=script&lang=js&"
import style0 from "./dashBoardmain.vue?vue&type=style&index=0&id=9ad2567c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad2567c",
  null
  
)

export default component.exports